import React from "react";

export const bold = (chunks: React.ReactNode[]) => <b>{chunks}</b>;
